import { useRef } from "react";

export default function SleekMultiSelect({
  placeholder = "Select...",
  options = [],
  selectedValues = [],
  selectedNames = [],
  onSelectionChange,
  isOpen,
  setOpen,
  innerRef,
  isSingleSelect = false,
  showSelectAll = true,
}) {
  const containerRef = useRef(null);

  const allSelected =
    options.length > 0 && selectedValues.length === options.length;

  const handleToggleAll = () => {
    if (allSelected) {
      onSelectionChange([], []);
    } else {
      const allIds = options.map((o) => o.id || o.name);
      const allNames = options.map((o) => o.name);
      onSelectionChange(allIds, allNames);
    }
  };

  return (
    <div className="jb-multiselect" ref={innerRef}>
      {/* INPUT BOX */}
      <div
        className="jb-multiselect-input"
        ref={containerRef}
        onClick={() => setOpen(!isOpen)}
      >
        <div className="jb-input-content">
          {selectedNames.length === 0 ? (
            <span className="jb-placeholder">{placeholder}</span>
          ) : (
            <div className="jb-chip-container">
              <span
                className="jb-chip jb-chip-primary"
                title={selectedNames[0]}
              >
                {selectedNames[0]}
              </span>

              {selectedNames.length > 1 && (
                <span className="jb-chip jb-chip-more">
                  +{selectedNames.length - 1}
                </span>
              )}
            </div>
          )}
        </div>

        {/* 🔽 DROPDOWN ARROW */}
        <span className={`jb-arrow ${isOpen ? "open" : ""}`}></span>
      </div>

      {/* DROPDOWN */}
      {isOpen && (
        <div className="jb-multiselect-dropdown">
          {/* SELECT ALL */}
          {showSelectAll && !isSingleSelect && (
            <>
              <div
                className="jb-multiselect-option select-all"
                onClick={handleToggleAll}
              >
                <input type="checkbox" checked={allSelected} readOnly />
                <span>{allSelected ? "Clear All" : "Select All"}</span>
              </div>
              <div className="jb-divider" />
            </>
          )}

          {/* OPTIONS */}
          {options.map((opt) => {
            const id = opt.id || opt.name;
            const selected = selectedValues.includes(id);

            return (
              <div
                key={id}
                className={`jb-multiselect-option ${
                  selected ? "selected" : ""
                }`}
                onClick={() => {
                  if (isSingleSelect) {
                    onSelectionChange([id], [opt.name]);
                    setOpen(false);
                    return;
                  }

                  if (selected) {
                    onSelectionChange(
                      selectedValues.filter((v) => v !== id),
                      selectedNames.filter((n) => n !== opt.name),
                    );
                  } else {
                    onSelectionChange(
                      [...selectedValues, id],
                      [...selectedNames, opt.name],
                    );
                  }
                }}
              >
                <input type="checkbox" checked={selected} readOnly />
                <span className="jb-option-label">
                  {opt.name}
                  {opt.iconUrl && (
                    <img src={opt.iconUrl} alt="" className="jb-icon" />
                  )}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
